import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { style } from './button-row.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'

@customElement('cse-button-row')
export class CSEButtonRow extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  override render() {
    return html`
      <div class="cse-button-row">
        <slot></slot>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-button-row': CSEButtonRow
  }
}
